import React, { useState, useEffect, useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import PresaleDetail from 'components/sales/leadDetails/presaleDetail/presaleDetail';
import PostsaleDetail from 'components/sales/leadDetails/postsaleDetail/postsaleLeadType';
import LeadDetail from 'components/sales/leadDetails/createLeadDetail/leadDetail';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Notfound from 'pages/notfound';
import { el } from 'date-fns/locale';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import {toast} from "react-toastify";

const ViewLead = ({ viewDetails, getContractDetails, match, history, contractInvoicePreview }) => {
  const { baseUrl } = useContext(BaseUrl);
  const [details, setDetails] = useState(null);
  const [leadId, setleadId] = useState();
  const [commId, setcommId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isRender, setIsRender] = useState(false);

  const role_id = window.localStorage.getItem("fusion-role");

  useEffect(() => {
    (async () => {
      if (localStorage.getItem('viewDetail') !== 'undefined') {
        const leadTypeId =
          (await JSON.parse(localStorage.getItem('viewDetail'))) &&
          JSON.parse(localStorage.getItem('viewDetail'))[0]?.lead_type_id;
        const requestData = {
          lead_id: leadId,
          commId:commId,
          lead_type: leadTypeId,
        };
        if (leadId) {
          setIsLoading(true);
          const res = await getContractDetails(requestData);
          if (res === null || res === '') {
            setIsRender(true);
          }
          setIsLoading(false);
        }
      }
    })();
  }, [getContractDetails, leadId,commId]);

  useEffect(() => {
    if (viewDetails) {
      setDetails(viewDetails);
    }
    setleadId(match.params.manageId ? match.params.manageId : match.params.id);
    setcommId(match.params.id ? match.params.id : match.params.id);
  }, [viewDetails, match.params]);
 
  const handleDiscard = async (commId, leadId, leadTypeId) => {
    if(commId) {
        if(window.confirm("Discard this contract?") == false) {
           return false;
        }
        const url = `${Config.viewDetails.discardContract}?commId=${commId}`;
        const { data } = await axios.get(url);
        if (data?.response?.data === true || data?.data === true) {
          toast.success('Contract Discard Successfully.');
          // history.push(`${baseUrl}/postSalesListing`)
          history.push(`${baseUrl}/contract-sales-listing/${leadTypeId}/${leadId}`);
        } else {
          toast.error('Contract Not Discard.');
        }
    } else {
      toast.error('Contract Id Not Found');
    }
  }

  const headerBtns = () => {
    return (
      <Fragment>
        {details?.lead_data && Object.keys(details?.lead_data).length > 0 && details?.lead_data?.com_status == 9 && (
          <a onClick={() => handleDiscard(commId, leadId, details?.lead_data?.lead_type_id)}
         className="btn btn-primary d-none d-md-inline-block">Discard</a>
        )}   
      </Fragment>
    );
  };


  return isRender ? (
    <Notfound />
  ) : (
    <Layout
      title={localization.BacktoList}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/site-listing`}
      Buttons={role_id != 11 && role_id != 12 ? headerBtns : null}
    >
      {details?.lead_data && Object.keys(details?.lead_data).length > 0 && (
        <LeadDetail details={details} />
      )}
      {details?.lead_data &&
        Object.keys(details?.lead_data).length > 0  && (
          <>
          
            {/* {details?.presale_data &&
              Object.keys(details?.presale_data).length > 0 && (
                <PresaleDetail details={details.presale_data} />
              )} */}

            {details?.postsale_data &&
              Object.keys(details?.postsale_data).length > 0 && (
                <PostsaleDetail
                 details={details.postsale_data}
                 clientBrd={details?.client_brd} 
                 modificationData={details?.modification_logs}
                 requiredDocuments={details?.required_documents_url}
                 contractInvoicePreview={contractInvoicePreview}
                 setIsLoading={setIsLoading}
                 />
              )}
              {/* <h5>Client BRD</h5> */}
          </>
        )}

      {/* {details?.lead_data &&
        Object.keys(details?.lead_data).length > 0 &&
        details?.lead_data?.site_information_feature_key && (
          <>
            {details?.presale_data &&
              Object.keys(details?.presale_data).length > 0 && (
                <PresaleDetail details={details.presale_data} />
              )}

            {details?.postsale_data &&
              Object.keys(details?.postsale_data).length > 0 && (
                <PostsaleDetail details={details.postsale_data} />
              )}
          </>
        )} */}
    </Layout>
  );
};

ViewLead.propTypes = {
  viewDetails: PropTypes.any,
  getContractDetails: PropTypes.func,
  match: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  history: PropTypes.object,
  contractInvoicePreview: PropTypes.func,
};

export default ViewLead;
